export default function PhilosophySection() {
  return (
    <section
      className="flex flex-col lg:flex-row w-full min-h-[600px]"
      aria-label="Engineering philosophy"
    >
      <div className="w-full lg:w-1/2 bg-accent-100 flex items-end px-10 md:px-16 pb-20 pt-28">
        <div>
          <span className="font-label text-xs uppercase tracking-[0.15em] text-foreground-500 mb-8 block">
            Our Approach
          </span>
          <h2 className="font-heading text-foreground-950 leading-[0.92]">
            <span className="block text-[3.5rem] md:text-[4rem] lg:text-[3.5rem] font-semibold">
              Scalable.
            </span>
            <span className="block text-[4.5rem] md:text-[5.2rem] lg:text-[4.5rem] font-semibold">
              Maintainable.
            </span>
            <span className="block text-[5.5rem] md:text-[6.5rem] lg:text-[5.5rem] font-semibold">
              Reliable.
            </span>
          </h2>
        </div>
      </div>
      <div className="w-full lg:w-1/2 bg-background-50 flex flex-col items-center justify-center px-10 md:px-20 py-20">
        <h3 className="font-body text-[2.5rem] md:text-[3rem] lg:text-[2.8rem] font-bold text-foreground-950 text-center leading-[1.1] mb-20">
          Built for the long run
        </h3>
        <p className="font-body text-base md:text-[1.05rem] text-foreground-600 text-center max-w-[34rem] leading-relaxed">
          We design and develop modern digital software solutions for the iOS platform and related technologies. 
          Every system we build is crafted with a focus on usability, stability, and long-term technical quality. 
          Our engineering practice revolves around clean architecture, performance optimization, and 
          user-centered design to create software that endures and adapts gracefully over time.
        </p>
      </div>
    </section>
  );
}